import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToSection = useCallback((sectionId) => {
    setMenuOpen(false);
    if (location.pathname === "/") {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: sectionId } });
    }
  }, [location.pathname, navigate]);

  return (
    <header className={`site-nav${scrolled ? " scrolled" : ""}`} role="banner">
      <nav className="nav-inner" aria-label="Main navigation">
        <Link to="/" className="nav-logo" aria-label="Hayden Bulk Tech Labs home">
          <img
            src="/hayden-bulk.png"
            alt="Hayden Bulk Tech Labs logo"
            width="46"
            height="44"
          />
          <span>Hayden Bulk Tech Labs</span>
        </Link>

        <ul className={`nav-links${menuOpen ? " open" : ""}`}>
          <li>
            <button
              type="button"
              className="nav-link-btn"
              onClick={() => scrollToSection("about")}
            >
              About
            </button>
          </li>
          <li>
            <button
              type="button"
              className="nav-link-btn"
              onClick={() => scrollToSection("products")}
            >
              Products
            </button>
          </li>
          <li>
            <button
              type="button"
              className="nav-link-btn"
              onClick={() => scrollToSection("services")}
            >
              Services
            </button>
          </li>
          <li>
            <Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link>
          </li>
          <li>
            <button
              type="button"
              className="nav-link-btn"
              onClick={() => scrollToSection("contact")}
            >
              Contact
            </button>
          </li>
        </ul>

        <div className="nav-cta">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => scrollToSection("contact")}
          >
            Book a Consultation
          </button>
        </div>

        <button
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    </header>
  );
};

export default Navbar;
